<template>
  <div class="constructionSite-main">
    <div class="constructionSite_content flex">
      <div class="content_left flexColumn" style="width: 25%">
        <div class="content_style" style="height: 28%">
          <div class="style_title">项目进度</div>
          <div class="style_content">
            <div class="flex" style="justify-content: space-around">
              <div class="bj_1">无事故安全生产天数</div>
              <div class="flex tian" :data-attr="content" style="width: 25%; position: relative">
                <div class="bj_2" v-for="(item, index) in safetyDay" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="flex" style="height: 82%">
              <v-chart theme="macarons" style="width: 100%; height: 100%" ref="echarts1" :options="option"></v-chart>
              <v-chart theme="macarons" style="width: 100%; height: 100%" ref="echarts2" :options="option1"></v-chart>
              <v-chart theme="macarons" style="width: 100%; height: 100%" ref="echarts3" :options="option2"></v-chart>
              <v-chart theme="macarons" style="width: 100%; height: 100%" ref="echarts4" :options="option3"></v-chart>
            </div>
          </div>
        </div>
        <div class="content_style" style="height: 28%">
          <div class="style_title" style="background-size: 100% 100%">
            近七天车辆出入场统计
          </div>
          <div class="style_content">
            <div class="flex" style="height: 100%">
              <v-chart theme="macarons" style="width: 100%; height: 100%" ref="echarts5"
                :options="uploadAndownLoadMonth"></v-chart>
            </div>
          </div>
        </div>
        <div class="content_style" style="height: 44%">
          <div class="style_title">项目动态</div>
          <div class="style_content hiddenScroll" style="overflow: auto">
            <div class="flexColumn l_3_style">
              <div class="flex" style="margin: 10px 0px" v-for="(item, index) in projectDynamic" :key="item.gdpm01">
                <div class="l_3_1_style"></div>
                <div style="text-align: center; font-size: 10px; width: 16%;line-height: 22px;">
                  <div style="white-space: pre-wrap;">{{ item.gdpm10 }}</div>
                </div>
                <el-tooltip class="item" effect="dark" :content="item.gdpm03" placement="top" style="cursor: pointer">
                  <div class="l_3_3_style textEllipsis" @click="peojectDunamicClick(item)">
                    {{ item.gdpm03 }}
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_center flexColumn" style="
          width: 75%;
          height: 100%;
          padding: 10px;
          justify-content: space-between;
        ">
        <div class="flex" style="height: 55.5%; justify-content: space-between">
          <div style="height: 100%; width: 64.5%" class="flexColumn">
            <div class="flex menuL" style="
                height: 50px;
                line-height: 28px;
                margin-bottom: 2px;
                overflow-x: auto;
                justify-content: space-between !important;
                white-space: nowrap;
              ">
              <div class="flex" style="justify-content: flex-start">
                <div v-for="(item, index) in multimediaList" class="menuStyle SYHT-Bold" style="margin-right: 10px"
                  :key="index" :class="{ isActive: item.is }" @click="skip(item)">
                  {{ item.gdpm06 }}
                </div>
              </div>
            </div>
            <div style="height: calc(100% - 40px); width: 100%" v-if="multimediaList.length">
              <video v-if="multimediaList.filter((el) => el.is)[0].gdpm07 == '视频'" :src="$store.state.baseUrl +
                multimediaList.filter((el) => el.is)[0].gdpm05
                " id="videoPath" ref="audio" poster="../../../assets/img/ycy-cy-3.png" autoplay loop muted
                controls="fasle" style="width: 100%; height: 100%; object-fit: unset"></video>
              <img v-else-if="multimediaList.filter((el) => el.is)[0].gdpm07 == '图片'
                " :src="$store.state.baseUrl +
    multimediaList.filter((el) => el.is)[0].gdpm05
    " style="width: 100%; height: 100%" alt />
              <BimModel v-else style="width: 100%; height: 100%; position: relative"
                :url="multimediaList.filter((el) => el.is)"></BimModel>
            </div>
          </div>
          <div style="width: 35%; height: 100%" class="flexColumn">
            <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" class="content_style" style="height: 44%">
              <div class="style_title">人员在岗情况</div>
              <div class="style_content flex">
                <div class="flex">
                  <img src="@/assets/img/Wisdom/色相_饱和度 6 灰大素材 1.png" width="60" alt="" />
                  <div class="flexColumn" style="align-items: start">
                    <div>在岗总人数</div>
                    <div style="
                        color: #04e8f8;
                        font-size: 22px;
                        font-family: fzfs !important;
                      ">
                      {{ this.rybd ? this.rybd.val : 5639 }}
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <img src="@/assets/img/Wisdom/色相_饱和度 6 灰大素材 1.png" width="60" alt="" />
                  <div class="flexColumn" style="align-items: start">
                    <div>新增在岗</div>
                    <div style="
                        color: #41ecc6;
                        font-size: 22px;
                        font-family: fzfs !important;
                      ">
                      {{ this.rybd ? this.rybd.val1 : 5639 }}
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <img src="@/assets/img/Wisdom/色相_饱和度 6 灰大素材 1.png" width="60" alt="" />
                  <div class="flexColumn" style="align-items: start">
                    <div>新增离岗</div>
                    <div style="
                        color: #f1b95b;
                        font-size: 22px;
                        font-family: fzfs !important;
                      ">
                      {{ this.rybd ? this.rybd.val2 : 5639 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_style" style="height: 100%">
              <div class="style_title">扬尘环境监测</div>
              <div class="style_content" style="height: calc(100% - 69px)">
                <div class="flex" style="flex-wrap: wrap; height: 100%">
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/PM2.5.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">PM2.5</div>
                      <div>
                        2.5<i style="font-size: 12px; color: #878787">μg/m³</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/PM10.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">PM10</div>
                      <div>
                        2.5<i style="font-size: 12px; color: #878787">μg/m³</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/TSP.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">TSP</div>
                      <div>
                        2.5<i style="font-size: 12px; color: #878787">μg/m³</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/风速.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">风速</div>
                      <div>
                        2.5<i style="font-size: 12px; color: #878787">m/s</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/风向.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">风向</div>
                      <div>西北风</div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/噪音.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">噪音</div>
                      <div>
                        2.5<i style="font-size: 12px; color: #878787">dB</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/温度.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">温度</div>
                      <div>
                        23<i style="font-size: 12px; color: #878787">℃</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/湿度.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">湿度</div>
                      <div>
                        23<i style="font-size: 12px; color: #878787">%rh</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex" style="width:33%;ju">
                    <img src="@/assets/img/Wisdom/风级.png" width="60" alt="" />
                    <div class="flexColumn" style="align-items: initial; width: 50%">
                      <div style="color: #3e9cf2">风级</div>
                      <div>
                        10<i style="font-size: 12px; color: #878787">级</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 44%; width: 100%; justify-content: space-between" class="flex">
          <div style="height: 100%; width: 40%">
            <div class="content_style" style="height: 100%">
              <div class="style_title">项目里程碑</div>
              <div class="style_content c_2_style hiddenScroll" style="overflow: auto">
                <div class="flexColumn">
                  <div style="width: 100%; position: relative" v-for="(item, index) in milestoneList" :key="item.gdpm01">
                    <div v-if="index % 2 != 1" class="c_2_1_style flex flexRL"
                      style="justify-content: left; position: relative">
                      <div class="flexColumn" style="align-items: initial; width: 37%">
                        <div class="textEllipsis">{{ item.gdpm03 }}</div>
                        <div style="
                            width: 100%;
                            height: 1px;
                            background-color: #2e52ff;
                          "></div>
                        <el-tooltip class="item" effect="dark" placement="top" style="cursor: pointer">
                          <div slot="content">
                            <div v-html="item.str"></div>
                          </div>
                          <div class="textEllipsis" v-html="item.str"></div>
                        </el-tooltip>
                      </div>
                      <div>
                        <img style="width: 56px; height: 57px; border-radius: 50%"
                          :src="$store.state.baseUrl + item.gdpm05" alt="" />
                      </div>
                      <div>
                        <img src="@/assets/img/Wisdom/icon 拷贝 7 灰大素材 1.png" width="28" height="28" alt="" />
                      </div>
                    </div>
                    <div v-else-if="index % 2 != 0" class="c_2_1_style flex"
                      style="justify-content: right; position: relative">
                      <div>
                        <img src="@/assets/img/Wisdom/Frame2.png" width="28" height="28" alt="" />
                      </div>
                      <div>
                        <img style="width: 56px; height: 57px; border-radius: 50%"
                          :src="$store.state.baseUrl + item.gdpm05" alt="" />
                      </div>
                      <div class="flexColumn" style="align-items: initial; width: 37%">
                        <div class="textEllipsis">{{ item.gdpm03 }}</div>
                        <div style="
                            width: 100%;
                            height: 1px;
                            background-color: #2e52ff;
                          "></div>
                        <el-tooltip class="item" effect="dark" placement="top" style="cursor: pointer">
                          <div slot="content">
                            <div v-html="item.str"></div>
                          </div>
                          <div class="textEllipsis" v-html="item.str"></div>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 100%; width: 59.2%">
            <div class="content_style" style="height: 100%">
              <div class="style_title2">能耗监测</div>
              <div class="style_content">
                <div class="flex" style="height: 100%">
                  <v-chart theme="macarons" ref="echarts6" style="width: 100%; height: 100%"
                    :options="uploadAndownLoadMonth2"></v-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 浮动组件 -->
    <el-drawer class="drawerStyle" title="内容详情" :modal="true" :close-on-press-escape="true" :modal-append-to-body="false"
      :visible.sync="drawer" :direction="direction">
      <div style="margin: 20px">
        <div v-html="projectDetails.gdpm04"></div>
        <!-- <img :src="$store.state.baseUrl + projectDetails.gdpm05" alt="" /> -->
        <!-- <ckediter4 ref="ck2" v-model="projectDetails.gdpm04"></ckediter4> -->
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  Getgdproschedule,
  Getgdpromessage,
  GetLwInfo,
  GetProjectInfo,
} from "@/setAxios.js";
import ckediter4 from "@/components/ck.vue";
import * as echarts from "echarts";
import BimModel from "../bimViewModelIfram.vue";
export default {
  name: "constructionSite",
  components: { BimModel, ckediter4 },
  data() {
    return {
      loading: false,
      drawer: false,
      direction: "rtl",
      projectDetails: {},
      //项目进度
      safetyDay: [],
      finallyRate: {},
      noStart: {},
      finished: {},
      starting: {},
      content: "",
      option: {},
      option1: {},
      option2: {},
      option3: {},
      uploadAndownLoadMonth: {
        color: ["#1E84FF", "#60D7A7"],
        tooltip: {
          trigger: "axis",
        },
        //图例
        legend: {
          //   icon: "circle", //形状
          itemHeight: 10,
          right: 10,
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          //线轴 虚线
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
          data: [1, 2, 3, 4, 5, 6, 7],
        },
        yAxis: {
          type: "value",
          // 轴线
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          //线轴 虚线
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
          // 刻度
          axisTick: {
            show: false,
          },
          splitArea: {
            show: false,
          },
        },
        series: [
          {
            name: "入场",
            data: Array.from(
              { length: 7 },
              (v) => Math.floor(Math.random() * (600 - 100)) + 100
            ),
            type: "line",
            symbol: "none", //去掉线上的圆点
            smooth: true, //是否平滑曲线
            areaStyle: {
              color: "#1E84FF", //阴影区域
              opacity: 0.2,
            },
          },
          {
            name: "出场",
            data: Array.from(
              { length: 7 },
              (v) => Math.floor(Math.random() * (600 - 100)) + 100
            ),
            type: "line",
            symbol: "none", //去掉线上的圆点
            smooth: true, //是否平滑曲线
            areaStyle: {
              color: "#60D7A7", //阴影区域
              opacity: 0.2,
            },
          },
        ],
        grid: {
          left: "8%",
          top: "8%",
          right: "3%",
          bottom: "12%",
        },
      },
      uploadAndownLoadMonth2: {
        color: ["#1E84FF", "#60D7A7"],
        tooltip: {
          trigger: "axis",
        },
        //图例
        legend: {
          //   icon: "circle", //形状
          itemHeight: 10,
          right: 10,
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          //线轴 虚线
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        yAxis: {
          type: "value",
          // 轴线
          axisLine: {
            show: false,
            lineStyle: {
              color: "#c3c3c3",
            },
          },
          //线轴 虚线
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
          // 刻度
          axisTick: {
            show: false,
          },
          splitArea: {
            show: false,
          },
        },
        series: [
          {
            name: "电",
            data: Array.from(
              { length: 15 },
              (v) => Math.floor(Math.random() * (300 - 100)) + 100
            ),
            type: "line",
            // symbol: "none", //去掉线上的圆点
            showSymbol: false,
            smooth: true, //是否平滑曲线
            areaStyle: {
              color: "#1E84FF", //阴影区域
              opacity: 0.2,
            },
          },
          {
            name: "水",
            data: Array.from(
              { length: 15 },
              (v) => Math.floor(Math.random() * (300 - 100)) + 100
            ),
            type: "line",
            // symbol: "none", //去掉线上的圆点
            showSymbol: false,
            smooth: true, //是否平滑曲线
            areaStyle: {
              color: "#60D7A7", //阴影区域
              opacity: 0.2,
            },
          },
        ],
        grid: {
          left: "8%",
          right: "3%",
          bottom: "12%",
        },
      },
      projectDynamic: [], //项目动态
      multimediaList: [], //多媒体
      milestoneList: [], //里程碑
      ///劳务
      rybd: {},
      projectCode: null,
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.$refs.echarts1.resize()
      this.$refs.echarts2.resize()
      this.$refs.echarts3.resize()
      this.$refs.echarts4.resize()
      this.$refs.echarts5.resize()
      this.$refs.echarts6.resize()
    })
  },
  created() {
    this.Getgdproschedule();
    this.Getgdpromessage(0);
    this.Getgdpromessage(1);
    this.Getgdpromessage(2);

    this.GetProjectInfos();
  },
  methods: {
    //人员在岗情况
    async GetProjectInfos() {
      let res = await GetProjectInfo({ params: { id: this.$store.state.xid } });
      this.projectCode = res.Data.proj02;
      this.GetLwInfo();
    },
    async GetLwInfo() {
      this.loading = true;
      let res = await GetLwInfo({ code: this.projectCode });
      this.loading = false;
      if (res.Data) {
        if (res.Data.rybd) {
          this.rybd = res.Data.rybd[0];
        }
      }
    },

    skip(item) {
      this.multimediaList.forEach((el) => {
        el.gdpm01 != item.gdpm01 ? (el.is = false) : (el.is = true);
      });
    },
    // 获取项目进度
    async Getgdproschedule() {
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        xid: Number(localStorage.xid),
      };

      let res = await Getgdproschedule({ params });
      loading.close();
      this.safetyDay = res.Data[0].gdps03.toString().split("");
      this.finallyRate = res.Data[1];
      this.noStart = res.Data[2];
      this.finished = res.Data[3];
      this.startIng = res.Data[4];
      this.content = res.Data[0].gdps04;

      this.option = {
        title: [
          {
            text: this.finallyRate.gdps03 + this.finallyRate.gdps04 + `\n`,
            left: "center",
            top: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
          {
            subtext: this.finallyRate.gdps02,
            left: "center",
            top: "center",
            subtextStyle: {
              fontSize: 14,
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
        ],
        // backgroundColor: '#111',
        polar: {
          //极坐标系地底板，类似于grid
          radius: ["50%", "70%"],
          center: ["50%", "50%"],
        },
        tooltip: {
          show: true,
        },
        angleAxis: {
          //角度轴，一个圆圈
          max: 100,
          show: false,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          //径向轴，一段线段，type:'category'类目轴，类似的x轴的类目轴
          type: "category",
          show: true,
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "",
            type: "bar", //柱状图
            roundCap: true,
            barWidth: 90,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(66, 66, 66, .3)",
            },
            data: [this.finallyRate.gdps03],
            coordinateSystem: "polar", //采用极坐标系

            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    //color为渐变色
                    offset: 0,
                    color: "#04e8f8",
                  },
                  {
                    offset: 1,
                    color: "#04e8f8",
                  },
                ]),
              },
            },
          },
          {
            name: "",
            type: "pie", //饼图
            startAngle: 90, //开始的角度
            radius: ["85%"],
            hoverAnimation: false,
            animation: false, //不开启动画，
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)", //饼图的颜色，设置为透明
              borderWidth: 0, //主要显示边框
              borderColor: "#5269EE",
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 80,
            radius: ["55%"],
            hoverAnimation: false,
            animation: false,
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)",
              borderWidth: 0,
              borderColor: "#5269EE",
            },
            data: [100],
          },
        ],
      };
      this.option1 = {
        title: [
          {
            text: this.noStart.gdps03 + this.noStart.gdps04 + `\n`,
            left: "center",
            top: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
          {
            subtext: this.noStart.gdps02,
            left: "center",
            top: "center",
            subtextStyle: {
              fontSize: 14,
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
        ],
        // backgroundColor: '#111',
        polar: {
          //极坐标系地底板，类似于grid
          radius: ["50%", "70%"],
          center: ["50%", "50%"],
        },
        tooltip: {
          show: true,
        },
        angleAxis: {
          //角度轴，一个圆圈
          max: 100,
          show: false,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          //径向轴，一段线段，type:'category'类目轴，类似的x轴的类目轴
          type: "category",
          show: true,
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "",
            type: "bar", //柱状图
            roundCap: true,
            barWidth: 90,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(66, 66, 66, .3)",
            },
            data: [this.noStart.gdps03],
            coordinateSystem: "polar", //采用极坐标系

            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    //color为渐变色
                    offset: 0,
                    color: "#5bda94",
                  },
                  {
                    offset: 1,
                    color: "#5bda94",
                  },
                ]),
              },
            },
          },
          {
            name: "",
            type: "pie", //饼图
            startAngle: 90, //开始的角度
            radius: ["85%"],
            hoverAnimation: false,
            animation: false, //不开启动画，
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)", //饼图的颜色，设置为透明
              borderWidth: 0, //主要显示边框
              borderColor: "#5269EE",
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 80,
            radius: ["55%"],
            hoverAnimation: false,
            animation: false,
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)",
              borderWidth: 0,
              borderColor: "#5269EE",
            },
            data: [100],
          },
        ],
      };
      this.option2 = {
        title: [
          {
            text: this.finished.gdps03 + this.finished.gdps04 + `\n`,
            left: "center",
            top: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
          {
            subtext: this.finished.gdps02,
            left: "center",
            top: "center",
            subtextStyle: {
              fontSize: 14,
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
        ],
        // backgroundColor: '#111',
        polar: {
          //极坐标系地底板，类似于grid
          radius: ["50%", "70%"],
          center: ["50%", "50%"],
        },
        tooltip: {
          show: true,
        },
        angleAxis: {
          //角度轴，一个圆圈
          max: 100,
          show: false,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          //径向轴，一段线段，type:'category'类目轴，类似的x轴的类目轴
          type: "category",
          show: true,
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "",
            type: "bar", //柱状图
            roundCap: true,
            barWidth: 90,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(66, 66, 66, .3)",
            },
            data: [this.finished.gdps03],
            coordinateSystem: "polar", //采用极坐标系

            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    //color为渐变色
                    offset: 0,
                    color: "#3674da",
                  },
                  {
                    offset: 1,
                    color: "#3674da",
                  },
                ]),
              },
            },
          },
          {
            name: "",
            type: "pie", //饼图
            startAngle: 90, //开始的角度
            radius: ["85%"],
            hoverAnimation: false,
            animation: false, //不开启动画，
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)", //饼图的颜色，设置为透明
              borderWidth: 0, //主要显示边框
              borderColor: "#5269EE",
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 80,
            radius: ["55%"],
            hoverAnimation: false,
            animation: false,
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)",
              borderWidth: 0,
              borderColor: "#5269EE",
            },
            data: [100],
          },
        ],
      };
      this.option3 = {
        title: [
          {
            text: this.startIng.gdps03 + this.startIng.gdps04 + `\n`,
            left: "center",
            top: "center",
            textStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
          {
            subtext: this.startIng.gdps02,
            left: "center",
            top: "center",
            subtextStyle: {
              fontSize: 14,
              color: "#FFFFFF",
              // fontFamily: "fzfs",
            },
          },
        ],
        // backgroundColor: '#111',
        polar: {
          //极坐标系地底板，类似于grid
          radius: ["50%", "70%"],
          center: ["50%", "50%"],
        },
        tooltip: {
          show: true,
        },
        angleAxis: {
          //角度轴，一个圆圈
          max: 100,
          show: false,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          //径向轴，一段线段，type:'category'类目轴，类似的x轴的类目轴
          type: "category",
          show: true,
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "",
            type: "bar", //柱状图
            roundCap: true,
            barWidth: 90,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(66, 66, 66, .3)",
            },
            data: [this.startIng.gdps03],
            coordinateSystem: "polar", //采用极坐标系

            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    //color为渐变色
                    offset: 0,
                    color: "#ebb559",
                  },
                  {
                    offset: 1,
                    color: "#ebb559",
                  },
                ]),
              },
            },
          },
          {
            name: "",
            type: "pie", //饼图
            startAngle: 90, //开始的角度
            radius: ["85%"],
            hoverAnimation: false,
            animation: false, //不开启动画，
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)", //饼图的颜色，设置为透明
              borderWidth: 0, //主要显示边框
              borderColor: "#5269EE",
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 80,
            radius: ["55%"],
            hoverAnimation: false,
            animation: false,
            center: ["50%", "50%"],
            itemStyle: {
              color: "rgba(66, 66, 66, .1)",
              borderWidth: 0,
              borderColor: "#5269EE",
            },
            data: [100],
          },
        ],
      };
    },
    async Getgdpromessage(type) {
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        xid: localStorage.xid,
        type: type,
        pageIndex: 1,
        pageSize: 10000,
      };
      let res = await Getgdpromessage({ params });
      // 正则
      let reg = /<(img+)[^>]*>(.*?<\/\1>)?/;
      loading.close();
      if (type == 0) {
        res.Data.list.forEach((el) => {
          this.multimediaList.push(el);
        });
        // 添加一个新的属性值
        this.multimediaList = this.multimediaList.map((item) => {
          return {
            ...item,
            is: false,
          };
        });
        // 给下标为0的对象is变为TRUE
        for (const key in this.multimediaList) {
          if (key == 0) {
            this.multimediaList[0].is = true;
          }
        }
      } else if (type == 1) {
        this.projectDynamic = res.Data.list.reverse();
      } else {
        this.milestoneList = res.Data.list;
        this.milestoneList.forEach((el) => {
          // 匹配图片
          let str = el.gdpm04.match(reg);
          // 若有图片替换，无则保持原来
          str != null
            ? (el.str = el.gdpm04.replace(str[0], ""))
            : (el.str = el.gdpm04);
          // debugger;
        });
      }
    },
    peojectDunamicClick(val) {
      this.drawer = true;
      this.projectDetails = val;
    },
  },
};
</script>
<style lang="less">
.constructionSite-main {
  width: 100%;
  height: calc(100% - 10px);
  padding-top: 10px;

  .constructionSite_content {
    width: 100%;
    height: 100%;

    .content_left {
      width: 24%;
      height: 100%;
    }
  }

  .flex {
    width: 100%;
  }

  .menuStyle {
    background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    padding: 0px 40px;
    box-sizing: content-box;
    width: 12%;
    height: 100%;
    color: #fff;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .isActive {
    background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
  }

  .l_3_style {
    width: 100%;
    // margin: 10px 0;
    // height: 100%;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 2px;
      height: 100%;
      background-color: #0681e7;
      left: 12px;
      top: 0;
    }
  }

  .c_2_style {
    position: relative;
  }

  .c_2_1_style {
    &::before {
      content: "";
      position: absolute;
      width: 2px;
      height: 100%;
      background-color: #0681e7;
      left: 49.8%;
      opacity: 0.2;
      top: 0;
    }
  }

  .l_3_3_style {
    width: 70%;
    border-radius: 10px;
    box-shadow: 0 0 4px 4px rgb(26, 87, 167) inset;
    padding: 10px;
  }

  .l_3_1_style {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: red;
    background-image: linear-gradient(rgb(0, 47, 255) 5%,
        rgb(0, 81, 255) 15%,
        rgb(10, 153, 219) 60%);
  }

  .flexRL:nth-child(odd) {
    justify-content: left;
  }

  .flexRL:nth-child(even) {
    justify-content: right;
  }

  .content_style {
    width: 100%;
    height: 33%;

    .style_title {
      background-image: url("../../../assets/img/Wisdom/Group 3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 14px;
      padding: 10px 25px;
      font-weight: bold;
      color: #fff;
    }

    .style_content {
      border-bottom: 2px solid #074b7c;
      height: calc(100% - 74px);
      margin-top: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      width: calc(100% -20px);
      padding: 10px;
      color: #fff;

      .bj_1 {
        background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        text-align: center;
        font-weight: bold;
        width: 40%;
        height: 30%;
      }

      .bj_2 {
        background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 10% center;
        text-align: center;
        font-weight: bold;
        padding: 8px;
        letter-spacing: 5px;
        font-size: 20px;
        text-align: center;
        color: #04e8f8;
        font-family: "fzfs" !important;
      }

      .tian {
        position: relative;

        &::after {
          position: absolute;
          content: attr(data-attr);
          right: -30%;
          color: #fff;
          bottom: 2px;
        }
      }
    }
  }

  .style_title2 {
    background-image: url("../../../assets/img/Wisdom/Group23.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-family: "fzfs";
    font-size: 14px;
    padding: 10px 25px;
    font-weight: bold;
    color: #fff;
  }

  .projectDrawer {
    background: #fff;
    position: fixed;
    width: 25%;
    height: 96%;
    color: #fff;
  }

  // drawer 修改背景色
  .el-drawer.rtl {
    background: #041732;
    border: 1px solid #0b6885;
    box-shadow: 0 0 10px 1px #04e8f8 inset; //外层的阴影（开始时）改变阴影内侧阴影
  }

  // 修改header文字大小颜色
  .el-drawer__header {
    color: #11c3b5;
    // font-size: 22px;
  }

  .el-drawer__body {
    color: #fff;

    div {
      p {
        overflow: auto !important;
      }
    }
  }
}
</style>
